module.exports = __webpack_public_path__ + "static/media/arlicar2.f89d7cc9.webp";